export interface ActiveTimerResponse {
  id: number;
  projectId: number | null;
  description: string | null;
  startedAt: string;
  accumulatedSeconds: number;
  isPaused: boolean;
  isLimitReached: boolean;
}

export enum TimerStopMode {
  Auto = 'auto',
  Manual = 'manual',
}

export interface StartTimerRequest {
  timezone: string;
  projectId?: number | null;
  description?: string | null;
}

export interface PauseTimerRequest {
  timezone: string;
}

export interface ResumeTimerRequest {
  timezone: string;
}

export interface UpdateTimerRequest {
  projectId?: number | null;
  description?: string | null;
  startedAt?: string;
  timezone?: string;
}

export interface StopTimerRequest {
  projectId: number;
  timezone: string;
  mode: TimerStopMode;
  description?: string | null;
  date?: string;
  trackedMinutesOverride?: number;
}
